import { isEmpty } from "lodash";
import { shallowEqual, useSelector } from "react-redux";
// components
import RMDRImage from "@/components/RMDRImage";
// types
import { TMainPageLayoutV3 } from "../type";
import TClientSiteSettingDetail from "@/cms/types/TClientSiteSettingDetail";
// utilities
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ESizeType from "@/cms/enums/ESizeType";


const MNPG066 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG066.rendered: ", props);

    const siteSettingsPayload:TClientSiteSettingDetail = useSelector((state:any) => state.SiteSettingStore.details.payload, shallowEqual);

    if ( !siteSettingsPayload || isEmpty(siteSettingsPayload) ) return null;

    const siteName = outerNameDescriptionLanguageVersion(siteSettingsPayload?.languageVersions);
    
    return (
        <div className="widget-head-logo">
            <RMDRImage
                resourceType={EResourceType.LOGO_DEFAULT} 
                resources={siteSettingsPayload?.resources} 
                sizeType={ESizeType.X06}
                alt={siteName?.name} 
                title={siteName?.name}
            />
        </div>
    )
}

export default MNPG066;
